import React, { Component } from "react";
import PropTypes from "prop-types";

// STATE AND STORE
// LIBS
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { Row, Col, Header, P, Label } from "../../../ui";

export default class DaySumsAll extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    saved: PropTypes.bool.isRequired,
    sumAll: PropTypes.shape({
      cashDeskStart: PropTypes.number.isRequired,
      sumGive: PropTypes.number.isRequired,
      sumPercent: PropTypes.number.isRequired,
      sumFine: PropTypes.number.isRequired,
      sumIncome: PropTypes.number.isRequired,
      sumReturn: PropTypes.number.isRequired,
      sumIncomeWithReturn: PropTypes.number.isRequired,
      sumAdd: PropTypes.number.isRequired,
      sumRemove: PropTypes.number.isRequired,
      sumClose: PropTypes.number.isRequired,
      cashDesk: PropTypes.number.isRequired
    }).isRequired
  };

  render() {
    let { loading, saved, sumAll } = this.props;

    if (loading || !saved) {
      return null;
    }

    return (
      <div>
        <Row>
          <Col padding="no-top-bottom">
            <Header size={3}>Общее</Header>
          </Col>
        </Row>

        <div className="sums-all-line">
          <div className="item cashDeskStart">
            <P slim={true} size="small">
              Начало дня
            </P>
            <Header margin="no">{sumFormat(sumAll.cashDeskStart)}</Header>
          </div>

          <div className="item sumGiveReturn">
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  Выдано
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumGive)}
                </P>
              </Col>
            </Row>
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  Получено
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumIncomeWithReturn)}
                </P>
              </Col>
            </Row>
            {/* <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  --> возвраты выдач
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumReturn)}
                </P>
              </Col>
            </Row>
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  --> проценты
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumPercent)}
                </P>
              </Col>
            </Row>
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  --> штрафы
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumFine)}
                </P>
              </Col>
            </Row> */}
          </div>

          <div className="item sumAddRemoveClose">
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  Пополнение
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumAdd)}
                </P>
              </Col>
            </Row>
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  Расход
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumRemove)}
                </P>
              </Col>
            </Row>
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="small">
                  Списание
                </Label>
              </Col>
              <Col padding="no" text="right">
                <P slim={true} strong={true}>
                  {sumFormat(sumAll.sumClose)}
                </P>
              </Col>
            </Row>
          </div>
          <div className="item cashDesk">
            <P slim={true} size="small">
              Конец дня
            </P>
            <Header margin="no">{sumFormat(sumAll.cashDesk)}</Header>
          </div>
        </div>
      </div>
    );
  }
}
